import AbstractRequestTask from '../../AbstractRequestTask';
import Launcher from '../../../apa/Launcher';
import Utils from '../../../../utils/Utils';

class MultiContentSearchV1Task extends AbstractRequestTask {
    constructor(groupIds = '') {
        super();
        this.group_ids = groupIds.groupIds;
        this.format_types = groupIds.formatTypes;
    }

    getHeaders() {
        const params = super.getParams();
        if (params.user_token) {
            return {
                Authorization: 'Bearer ' + params.user_token,
            };
        } else {
            return {};
        }
    }

    getEncType() {
        return 'multipart/form-data';
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        let _url = `${http}${url}/services/payway/paymentservice/v1/multicontentsearch?`;
        _url += Utils.buildQueryParams(this.getGETParams());
        return _url;
    }

    getMethod() {
        return 'POST';
    }

    getParams() {
        const params = {};
        params.extra_params = this.format_types; // JSON.stringify({"group_ids":{"833500":{"format_types":"susc"},"922082":{"format_types":"susc"}}}) // JSON.stringify({group_ids: this.group_ids});

        return params;
    }

    getShowErrorModal() {
        return false;
    }

    getGETParams() {
        const params = super.getParams();

        const paramsServicie = {
            user_id: params.user_id,
            region: params.region,
            authpn: params.authpn,
            authpt: params.authpt,
            device_id: params.device_id,
            device_category: params.device_category,
            device_manufacturer: params.device_manufacturer,
            device_model: params.device_model,
            device_type: params.device_type,
            format: params.format,
        };

        return paramsServicie;
    }

    getRetriesNumber() {
        return 0;
    }

    success(data, b) {
        this.resolve(data);
    }

    isValid(data) {
        if (data.errors || !data.data) {
            return false;
        }
        return true;
    }

}

export default MultiContentSearchV1Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/v1/MultiContentSearchV1Task.js